export enum RANGING_STATUS {
    ACTIVE = 1,
    INACTIVE = 0
  }